
<template>
    <flex-element
        v-plaintext
        class-default-inline="f-relative f-text-center f-cursor-pointer"
        :type="renderType"
        :style="buttonStyle"
        :element-type="elementType"
        @click.native="showOnMap"
    >
        <span
            v-text-select="singleLineTextNew"
            :contenteditable="isContentEditable"
            :style="textStyle"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AShowOnMap } from '@/data/data-models';

export default {
    name: 'a-google-map-show-on-map',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Show on Map link',
        },

        coordinates: {
            type: String,
            default: '',
        },

        name: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        tag: {
            type: String,
            default: 'button',
        },

        templateId: {
            type: String,
            default: '{3608E54F-8A75-4FC6-AD2C-5B9392883DF5}',
        },

        singleLineText: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            singleLineTextNew: 'Show on Map',
        };
    },

    computed: {
        renderType() {
            return this.typeNew || this.typeDefault;
        },

        buttonStyle() {
            return {
                pointerEvents: this.isLoading ? 'none' : 'auto',
            };
        },

        textStyle() {
            return {
                visibility: this.isLoading ? 'hidden' : 'visible',
            };
        },

        updatedElement() {
            return new AShowOnMap({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew,
                type: this.typeNew,
                coordinates: this.coordinates,
            });
        },
    },

    methods: {
        showOnMap() {
            if (this.coordinates) {
                this.$root.$emit('flex::google-map::showOnMap', this.coordinates);
            }
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },
    },
};
</script>
